import { Package, PackageItem } from "models/packages"
import { http } from "./http"
import { Paginated } from "./types"

export const fetchPackages = async (_key: string, params: any) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("packages", { searchParams }).json()
  return res as Paginated<Package>
}

export const fetchPackageItems = async (
  _key: string,
  id: string,
  params: any,
) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get(`packages/${id}/items`, { searchParams }).json()
  return res as PackageItem[]
}

export const createPackage = async (args: Partial<Package>) => {
  return http.post("packages", { json: args }).json()
}

export const deletePackage = async (id: string) => {
  const res = await http.delete(`packages/${id}`)
  return res
}

export const fetchPackage = (_key: string, id: string) => {
  return http.get(`packages/${id}`).json<Package>()
}
export const fetchPackageItem = (_key: string, id: string) => {
  return http.get(`packages/items/${id}`).json<PackageItem>()
}

interface CreateItem extends PackageItem {
  id: string
}

export const createPackageItem = async (args: Partial<CreateItem>) => {
  const { id, ...data } = args
  const res = await http.post(`packages/${id}/items`, { json: data }).json()
  return res as Partial<PackageItem>[]
}

export const activatePackage = async (id: string) => {
  const res = await http.post(`packages/${id}/activate`)
  return res
}
export const deactivatePackage = async (id: string) => {
  const res = await http.post(`packages/${id}/deactivate`)
  return res
}

export async function patchPackage(pld: Partial<Package> & { id: string }) {
  const { id, ...data } = pld
  const res = await http.patch(`packages/${id}`, { json: data })
  return res
}

export const deletePackageItem = async (id: string) => {
  const res = await http.delete(`packages/items/${id}`)
  return res
}

export async function patchPackageItem(
  pld: Partial<PackageItem> & { id: string },
) {
  const { id, ...data } = pld
  const res = await http.patch(`packages/items/${id}`, { json: data })
  return res as any
}
